import { render, staticRenderFns } from "./AiCostReport.vue?vue&type=template&id=52715266&scoped=true&"
import script from "./AiCostReport.vue?vue&type=script&lang=js&"
export * from "./AiCostReport.vue?vue&type=script&lang=js&"
import style0 from "./AiCostReport.vue?vue&type=style&index=0&id=52715266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52715266",
  null
  
)

export default component.exports